import apiService from "../common/commonApi";

export const approve = {};

approve.list = async (param) => {    
    return apiService.Get('approve-list', param);
}
